import { Environment } from './environment.interface';

export const environment: Environment = {
  production: false,
  env: 'staging',
  // api_base_url: '/api',
  api_base_url: 'https://api-stg.whitehelmet.sa/api',
  base_url: 'https://stg.whitehelmet.sa',
  new_login_url: 'https://login-stg.whitehelmet.sa/sign-in',
  pre_title: 'WhiteHelmet | ',
  appVersion: require('../../package.json').version + '-stg',
  googleAnalyticsId: 'G-7V4KPZVQJJ', // Omer
  hotjarId: 3800197,
  bim360Id: '9qKSy90crV6ldSZibg85Tl14ATAsDtsq',
  measurement_base_url: 'https://measurements-stg.whitehelmet.sa',
  asif_webapp_url: 'https://stg-asif-fe.whitehelmet.sa',
  authorization_api_base_url: 'https://stg-authorization-microservice.whitehelmet.sa/api',
  bim360SecretId: 'ln7GdBns82fQrLwB',
  authorization_service_url: 'https://tmp-home.whitehelmet.sa/api',
  notificationTimeInterval: 30000,
  heartbeatTimeInterval: 60000, // 60sec
  dms_frontend_url: 'https://dms-frontend-stg.whitehelmet.sa',
  gis_frontend_url: 'https://core-uat.whitehelmet.sa',
  report_builder_url: 'https://report-builder-stg.whitehelmet.sa',
  queue_status_polling_interval: 60000,
  firebaseConfig: {
    apiKey: 'AIzaSyCR0u4N39VttjXk8bvbc1oU3eKhp8alF7E',
    authDomain: 'whitehelmet-business.firebaseapp.com',
    projectId: 'whitehelmet-business',
    storageBucket: 'whitehelmet-business.appspot.com',
    messagingSenderId: '20172829853',
    appId: '1:20172829853:web:cd085771af6a40b6479074',
    measurementId: 'G-X02KFKQT2V',
  },
  oauth: {
    client_id: 'dms-frontend',
    origin: 'https://stg-keycloak.whitehelmet.sa',
    realm: 'staging',
    grant_type: 'password',
  },
  req352ClientId: 'abde327f-9218-4b2c-b35b-cb224bb29124',
};
